__turbopack_context__.v({
  "playButton": "style-module-scss-module__2ljf2a__playButton",
  "playIcon": "style-module-scss-module__2ljf2a__playIcon",
  "player": "style-module-scss-module__2ljf2a__player",
  "videoContainer": "style-module-scss-module__2ljf2a__videoContainer",
});
